module.exports = __webpack_public_path__ + "img/bh.a3459220.svg";